import React, { FC, useEffect, useRef } from 'react';
import { SelectContentMultiple } from "./SelectContentMultiple";
import { SelectContentSimple } from "./SelectContentSimple";
import { setClass } from '../../utils';

interface SelectContentProps {
  value: any;
  placeholder: string;
  multiple: boolean;
  searchValue: string;
  search?: boolean;
  isMenuOpen?: boolean;
  commonContent?: boolean; //если true - элемент отображается как в renderOption, иначе через Chip
  smallArrow?: boolean;
  renderOption?: (option: unknown, isSelected: boolean) => JSX.Element;
  getOptionLabel?: (option: unknown) => string;
  getOptionId?: (option: unknown) => string | number;
  onChangeSearch?: (value: string) => void;
}

export const SelectContent: FC<SelectContentProps> = ({
  value, placeholder, multiple, searchValue, isMenuOpen, search, commonContent, smallArrow,
  renderOption, getOptionId, getOptionLabel, onChangeSearch
}) => {
  const searchRef = useRef<HTMLInputElement>();

  useEffect(() => {
    isMenuOpen ? searchRef.current?.focus() : searchRef.current?.blur();
  }, [isMenuOpen, searchRef.current]);

  return <div className={setClass("content-wrapper", smallArrow && 'small')}>
    {search && (
      <input
        className="search-input"
        placeholder={placeholder}
        value={searchValue}
        onChange={(e) => onChangeSearch(e.target.value)}
        autoFocus
      />
    )}
    {multiple
      ? <SelectContentMultiple
        value={value}
        placeholder={placeholder}
        search={search}
        getOptionId={getOptionId}
        getOptionLabel={getOptionLabel}
      />
      : <SelectContentSimple
        value={value}
        placeholder={placeholder}
        search={search}
        commonContent={commonContent}
        getOptionLabel={getOptionLabel}
        renderOption={renderOption}
      />
    }
  </div>;
};